import { z } from "zod";

export const bulkTenderStatusSchema = z.enum([
	"processing",
	"select_carrier",
	"details_needed",
	"ready_to_tender",
	"under_review",
	"tendered",
	"failed",
]);

const bulkTenderFieldsSchema = z.object({
	bulkTenderStatus: bulkTenderStatusSchema.nullish(),
	bulkTenderReasonCode: z.string().nullish(),
	bulkTenderReason: z.string().nullish(),
});

export const QuoteBoardItemSchema = z
	.object({
		quoteId: z.number(),
		source: z.string(),
		customerId: z.number().nullable(),
		customerName: z.string().nullable(),
		shipmentDate: z.string().nullable(),
		createdByName: z.string().nullable(),
		poNumber: z.number().nullable(),
		originAddress: z.string().nullable(),
		destinationAddress: z.string(),
		totalWeight: z.number().nullable(),
		customerRate: z.number().nullable(),
		statusLevelId: z.number().nullable(),
		statusLevel: z.string().nullable(),
		carrierName: z.string().nullable(),
		carrierRate: z.number().nullable(),
		transitDays: z.number().nullish(),
		maxLiability: z.string(),
		margin: z.number().nullable(),
		ltlOwnerId: z.number().nullable(),
		ltlOwner: z.string().nullable(),
		ftlOwnerId: z.number().nullable(),
		ftlOwner: z.string().nullable(),
		customerReferences: z.string().nullable(),
		selectedCarrierPriceId: z.number().nullish(),
		insuranceValue: z.number().nullish(),
		insuranceApplyTypeId: z.number().nullish(),
		insuranceProductTypeId: z.number().nullish(),
		createdDate: z.string().nullable(),
		bulkReceivedAtUtc: z.string().nullish(),
		expirationDate: z.string().nullable(),
		tabType: z.string(),
		maxLiabilityNew: z.number().nullish(),
		maxLiabilityUsed: z.number().nullish(),
		maxLiabilityOverride: z.number().nullish(),
		eTag: z.string().nullish(),
		bulkQuoteId: z.string().uuid().nullable(),
		requestCount: z.number().nullable(),
		processedCount: z.number().nullable(),
		errorCount: z.number().nullable(),
		bulkUploadException: z.string().nullable(),
		isLtlTender: z.boolean().nullish(),
	})
	.extend(bulkTenderFieldsSchema.shape);

export const customerQuoteBoardItemSchema = z
	.object({
		quoteId: z.number(),
		originAddress: z.string(),
		destinationAddress: z.string(),
		totalWeight: z.number().nullable(),
		statusLevelId: z.number(),
		statusLevel: z.string(),
		carrierRate: z.number().nullable(),
		transitDays: z.number().nullish(),
		createdDate: z.string(),
		bulkReceivedAtUtc: z.string().nullish(),
		expirationDate: z.string(),
		tabType: z.string(),
		isActive: z.boolean(),
		createdByEmail: z.string(),
		poNumbers: z.string().nullable(),
		soNumbers: z.string().nullable(),
		blNumber: z.string().nullable(),
		customerReferences: z.string().nullable(),
		bulkQuoteId: z.string().uuid().nullable(),
		requestCount: z.number().nullable(),
		processedCount: z.number().nullable(),
		errorCount: z.number().nullable(),
		shipmentDate: z.string().nullable(),
		carrierName: z.string().nullable(),
		maxLiability: z.string().nullable(),
		selectedCarrierPriceId: z.number().nullish(),
		insuranceValue: z.number().nullish(),
		insuranceApplyTypeId: z.number().nullish(),
		insuranceProductTypeId: z.number().nullish(),
		maxLiabilityNew: z.number().nullish(),
		maxLiabilityUsed: z.number().nullish(),
		maxLiabilityOverride: z.number().nullish(),
		eTag: z.string().nullish(),
		createdByName: z.string().nullable(),
		ltlOwnerId: z.number().nullable(),
		ltlOwner: z.string().nullable(),
		ftlOwnerId: z.number().nullable(),
		ftlOwner: z.string().nullable(),
		bulkUploadException: z.string().nullable(),
		isLtlTender: z.boolean().nullish(),
	})
	.extend(bulkTenderFieldsSchema.shape);

export type QuoteBoardItem = z.infer<typeof QuoteBoardItemSchema>;
export type CustomerQuoteBoardItem = z.infer<
	typeof customerQuoteBoardItemSchema
>;
export type BulkTenderStatus = z.infer<typeof bulkTenderStatusSchema>;
